import * as Redux from 'redux'
import { Grid } from '@mui/material'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import ClientFirearmActions from '@ClientActions/firearm.action'
import BoxTitle from '@Components/Form/BoxTitle/BoxTitle'
import PageHeader from '@Components/Pages/PageHeader/PageHeader'
import Accessories from './Accessories'
import Firearms from './Firearms'
import { ICommonQuery } from '../../../models/common.model'

function MyVault(props: any) {
    const {
        firearms,
        getFirearms,
        getAccessories,
        accessories,
        parts,
        getParts,
    } = props

    const initialVault = () => {
        const params = {
            statuses: 'BOUGHT|STOLEN|LOST',
            isDetail: true,
        }
        getFirearms(params)
        getAccessories(params)
        getParts(params)
    }

    useEffect(() => {
        initialVault()
    }, [])

    return (
        <div className="my-vault">
            <PageHeader title="My Vault" />
            <BoxTitle title="Firearms" />

            <Grid container spacing={3}>
                {/* <Grid item xs={12}> */}
                <Firearms
                    itemType="FIREARM"
                    data={firearms}
                    submitChanged={initialVault}
                />
                {!firearms?.length && <p className="no-data">No data</p>}
                {/* </Grid> */}
            </Grid>

            <BoxTitle title="Accessories" className="mt-4" />
            <Grid container spacing={3}>
                {/* Accessory list */}
                <Firearms
                    itemType="ACCESSORY"
                    data={accessories}
                    submitChanged={initialVault}
                />
                {!accessories?.length && <p className="no-data">No data</p>}
            </Grid>

            <BoxTitle title="Parts" className="mt-4" />
            <Grid container spacing={3}>
                {/* Part list */}
                <Firearms
                    itemType="PART"
                    data={parts}
                    submitChanged={initialVault}
                />
                {!parts?.length && <p className="no-data">No data</p>}
            </Grid>
        </div>
    )
}

const mapStateToProps = (store: any) => {
    return {
        firearms: store?.client?.firearms?.firearmData,
        accessories: store?.client?.accessories?.accessoriesData,
        parts: store?.client?.parts?.partData,
    }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    return {
        getFirearms: (params: ICommonQuery) =>
            dispatch(ClientFirearmActions.getItems('FIREARM', params) as any),
        getAccessories: (params: ICommonQuery) =>
            dispatch(ClientFirearmActions.getItems('ACCESSORY', params) as any),
        getParts: (params: ICommonQuery) =>
            dispatch(ClientFirearmActions.getItems('PART', params) as any),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyVault)
